/* =========================
   PEGUU — HEADER
========================= */

(function () {
  const HEADER_SELECTOR = ".peguu-header";
  const MENU_BUTTON_SELECTOR =
    ".peguu-header__menu-button";
  const DRAWER_SELECTOR =
    ".peguu-header__drawer";

  const HOW_HASH = "#comofunciona";


  /* =========================
     ELEMENTOS
  ========================= */

  function getHeader() {
    return document.querySelector(
      HEADER_SELECTOR
    );
  }

  function getMenuButton() {
    const header = getHeader();

    if (!header) {
      return null;
    }

    return header.querySelector(
      MENU_BUTTON_SELECTOR
    );
  }

  function getDrawer() {
    const header = getHeader();

    if (!header) {
      return null;
    }

    return header.querySelector(
      DRAWER_SELECTOR
    );
  }


  /* =========================
     MENÚ MÓVIL
  ========================= */

  function closeDrawer() {
    const menuButton =
      getMenuButton();

    const drawer =
      getDrawer();

    if (
      !menuButton ||
      !drawer
    ) {
      return;
    }

    drawer.classList.remove(
      "is-open"
    );

    menuButton.setAttribute(
      "aria-expanded",
      "false"
    );
  }


  function toggleDrawer() {
    const menuButton =
      getMenuButton();

    const drawer =
      getDrawer();

    if (
      !menuButton ||
      !drawer
    ) {
      return;
    }

    const isOpen =
      drawer.classList.toggle(
        "is-open"
      );

    menuButton.setAttribute(
      "aria-expanded",
      String(isOpen)
    );
  }


  /* =========================
     CÓMO FUNCIONA
  ========================= */

  function getHowOffset() {
    return window.innerWidth <= 749
      ? 190
      : 170;
  }


  function scrollToHow(
    behavior = "smooth"
  ) {
    const target =
      document.querySelector(
        HOW_HASH
      );

    if (!target) {
      return false;
    }

    const targetPosition =
      target
        .getBoundingClientRect()
        .top +
      window.scrollY -
      getHowOffset();

    window.scrollTo({
      top: targetPosition,
      behavior: behavior
    });

    return true;
  }


  /* =========================
     CLICK GLOBAL
  ========================= */

  function handleDocumentClick(
    event
  ) {

    /* =========================
       BOTÓN HAMBURGUESA
    ========================= */

    const menuButton =
      event.target.closest(
        MENU_BUTTON_SELECTOR
      );

    if (menuButton) {
      event.stopPropagation();

      toggleDrawer();

      return;
    }


    /* =========================
       CÓMO FUNCIONA
    ========================= */

    const howLink =
      event.target.closest(
        'a[href*="#comofunciona"]'
      );

    if (howLink) {
      const target =
        document.querySelector(
          HOW_HASH
        );

      /*
       * Si #comofunciona existe,
       * significa que estamos en Home.
       *
       * Hacemos nuestro scroll personalizado.
       *
       * Si no existe, dejamos que el enlace
       * navegue normalmente hacia:
       *
       * /#comofunciona
       */
      if (target) {
        event.preventDefault();

        history.replaceState(
          null,
          "",
          `${window.location.pathname}${window.location.search}${HOW_HASH}`
        );

        scrollToHow(
          "smooth"
        );

        closeDrawer();

        return;
      }
    }


    /* =========================
       ENLACES DEL DRAWER
    ========================= */

    const drawerLink =
      event.target.closest(
        ".peguu-header__drawer a"
      );

    if (drawerLink) {
      closeDrawer();

      return;
    }


    /* =========================
       CLICK FUERA DEL DRAWER
    ========================= */

    const drawer =
      getDrawer();

    const currentMenuButton =
      getMenuButton();

    if (
      !drawer ||
      !drawer.classList.contains(
        "is-open"
      )
    ) {
      return;
    }

    const clickedInsideDrawer =
      drawer.contains(
        event.target
      );

    const clickedMenuButton =
      currentMenuButton &&
      currentMenuButton.contains(
        event.target
      );

    if (
      !clickedInsideDrawer &&
      !clickedMenuButton
    ) {
      closeDrawer();
    }
  }


  /* =========================
     TECLADO
  ========================= */

  function handleDocumentKeydown(
    event
  ) {
    if (
      event.key === "Escape"
    ) {
      closeDrawer();
    }
  }


  /* =========================
     CORREGIR POSICIÓN DEL HASH
  ========================= */

  function correctHowHashPosition(
    behavior = "auto"
  ) {
    if (
      window.location.hash !==
      HOW_HASH
    ) {
      return;
    }

    scrollToHow(
      behavior
    );
  }


  /* =========================
     EVENTOS GLOBALES
  ========================= */

  function bindGlobalEvents() {
    const html =
      document.documentElement;

    if (
      html.dataset
        .peguuHeaderEventsBound ===
      "true"
    ) {
      return;
    }

    html.dataset
      .peguuHeaderEventsBound =
      "true";


    document.addEventListener(
      "click",
      handleDocumentClick
    );


    document.addEventListener(
      "keydown",
      handleDocumentKeydown
    );


    /*
     * Segunda corrección después
     * de cargar imágenes y fuentes.
     */
    window.addEventListener(
      "load",
      function () {
        if (
          window.location.hash !==
          HOW_HASH
        ) {
          return;
        }

        setTimeout(
          function () {
            correctHowHashPosition(
              "auto"
            );
          },
          100
        );
      }
    );
  }


  /* =========================
     INICIALIZAR HEADER
  ========================= */

  function initPeguuHeader() {
    const header =
      getHeader();

    if (!header) {
      return;
    }

    const menuButton =
      getMenuButton();

    if (menuButton) {
      menuButton.setAttribute(
        "aria-expanded",
        "false"
      );
    }

    bindGlobalEvents();


    /*
     * Cuando llegamos desde otra página:
     *
     * /#comofunciona
     *
     * esperamos a que el navegador
     * acomode primero el contenido.
     */
    if (
      window.location.hash ===
      HOW_HASH
    ) {
      requestAnimationFrame(
        function () {
          requestAnimationFrame(
            function () {
              correctHowHashPosition(
                "auto"
              );
            }
          );
        }
      );
    }
  }


  /* =========================
     DOM READY
  ========================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initPeguuHeader
    );
  } else {
    initPeguuHeader();
  }


  /* =========================
     SHOPIFY THEME EDITOR
  ========================= */

  document.addEventListener(
    "shopify:section:load",
    initPeguuHeader
  );
})();